import React from "react";
import PragatiLogo from "./../../assets/pragati-tag.svg";

export const Pragati = ({ className, title, isValidProject, prgaticss }) => {
  return isValidProject || prgaticss ? (
    <div
      className={className}
      style={{ visibility: prgaticss ? "hidden" : null }}
    >
      <img src={PragatiLogo} />
    </div>
  ) : null;
};
